<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <app-toggle-menu-back-btn></app-toggle-menu-back-btn>
    </ion-buttons>
    <ion-title>
      <app-title-first-word-change title="my_bookmarks"></app-title-first-word-change>
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>

  <app-big-msg-dialog *ngIf="bookmarks.length == 0" 
    is_no_padding="true"
    ion_icon="bookmark-outline"
    text="no_bookmarks_text"
  ></app-big-msg-dialog>

  <ion-reorder-group (ionItemReorder)="doReorder($event)" disabled="false">
    <ng-container *ngFor="let bookmark of bookmarks">
      <app-bookmark-item [bookmark]="bookmark" viewMode="row"></app-bookmark-item>
    </ng-container>
  </ion-reorder-group>

</ion-content>

<ion-footer class="no-border">
  <app-big-msg-dialog *ngIf="!isPremium && bookmarks.length > 0"
    ion_icon="bookmark-outline"
    text="more_bookmarks_premium"
    [btn_text]="hasFreePremiumGrant ? 'get_premium_supporter' : 'get_premium'"
    (btn_callback)="premiumOptions.openPremium('bookmarks')"
  ></app-big-msg-dialog>
</ion-footer>
